export default {
  areaClassifier: '/dashboard/area-classifier',
};
